import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export function useDebounce<T>(
  valueDefault: T,
  delay = 500,
  setYourValue?: Dispatch<T>,
): [
  debounceValue: T,
  setValue: Dispatch<SetStateAction<T>>,
  currentValue: T,
  setValueWithoutDebouce: Dispatch<SetStateAction<T>>,
] {
  const [value, setValue] = useState<T>(valueDefault);
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    setValue(valueDefault);
    setDebouncedValue(valueDefault);
  }, [valueDefault]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      setYourValue && setYourValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, setYourValue]);
  return [debouncedValue, setValue, value, setDebouncedValue];
}
